<template>
  <div class='introduce'>
    <div class="banner">
      <p>产品与服务</p>
      <p>让你更安心、更放心、更省心</p>
    </div>

    <div class="head">
      <div class="en-title">Independent research and development of products</div>
      <div class="chs-title">自主研发产品-线上线下教育生态体系</div>
    </div>
    <div class="isms"></div>

    <div class="head">
      <div class="en-title">Cooperate in the development of products</div>
      <div class="chs-title">合作研发产品---社区服务系统</div>
    </div>

    <div class="app1">
      <img :src="require('@/assets/app1.png')" />
      <img :src="require('@/assets/app2.png')" />
      <img :src="require('@/assets/app3.png')" />
    </div>

    <div class="head">
      <div class="en-title">Cooperate in the development of products</div>
      <div class="chs-title">合作研发产品---养老平台</div>
    </div>

    <div class="app2">
      <img :src="require('@/assets/app4.png')" />
      <img :src="require('@/assets/app5.png')" />
      <img :src="require('@/assets/app6.png')" />
    </div>

    <div class="head">
      <div class="en-title">Cooperate in the development of products</div>
      <div class="chs-title">合作开发产品---智慧幼儿园系统</div>
    </div>

    <div class="app3">
      <img :src="require('@/assets/app7.png')" />
      <img :src="require('@/assets/app8.png')" />
      <img :src="require('@/assets/app9.png')" />
      <img :src="require('@/assets/app10.png')" />
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  created () {
  },
  methods: {
  },
}
</script>

<style scoped lang='less'>
.introduce {
  min-height: calc(100vh - 61px - 150px);
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 374px;
    color: #fff;
    text-align: center;
    background: url('../assets/service.png') no-repeat;
    background-size: cover;
    margin-bottom: 120px;
    p:first-child {
      font-size: 42px;
    }
    p:last-child {
      font-size: 30px;
    }
  }
  .head {
    width: 1520px;
    margin: 0 auto 60px;
  }
  .isms {
    width: 1200px;
    height: 500px;
    margin: 0 auto 200px;
    background: url('../assets/service1.png') no-repeat;
    background-size: cover;
  }
  .app1,
  .app2,
  .app3 {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto 200px;
    img {
      width: 196px;
      height: 409px;
    }
  }
}
</style>
